<template>
  <el-dialog
    :title="dialogTitle"
    width="900px"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @closed="isShow=false"
    :key="currentTimer"
    :append-to-body="true"
  >
    <el-row :gutter="10" style="margin-bottom:10px;">
      <el-col :span="6">
        <el-input v-model.trim="form.name" placeholder="请输入属性名称"></el-input>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="default" @click="handleReset">重置</el-button>
      </el-col>
      <el-col :span="12" style="display: flex;align-items:center;justify-content: flex-end;padding-right: 10px;">
        未找到属性？<el-link type="primary" :underline="false" @click="handleAddAttribute">添加属性</el-link>
      </el-col>
    </el-row>
    <TableWithPagination
      size='mini'
      :tableData="targetLists"
      :columnList="columnList"
      row-key='id'
      ref="checkboxTable"
      :checkbox-config="checkboxConfig"
      :pagination.sync="pagination"
      @size-change="getTargetLists"
      @selection-change="handleSelectionChange"
      max-height="400px"
      @current-change="getTargetLists"
      :sortInfo.sync="sortInfo"
      @sort-change="getTargetLists">
    </TableWithPagination>
    <ContentBlock title="已选属性" style="padding:0;">
      <TableWithPagination
        size='mini'
        :tableData="cloneSelectedLists"
        :columnList="selectedColumnList"
        max-height="400px">
      </TableWithPagination>
    </ContentBlock>
    <div slot="footer">
      <el-button size="mini" @click="isShow = false">取消</el-button>
      <el-button type="primary" size="mini" @click="handleConfirm">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { getAttributeLists } from '@/api/PlatformSales/ProductAttributes';
import { batchAddAttributeItem } from '@/api/PlatformSales/Category.js';
export default {
  name: '',
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  methods: {
    initPage () {
      this.form = this.form = this.$options.data().form;
      this.isShow = true;
      this.currentTimer = Date.now();
      this.targetLists = [];
      this.selectedLists = [];
      this.cloneSelectedLists = [];
      if (this.selectedItemLists && this.selectedItemLists.length) {
        this.getSelectedLists();
      } else {
        this.handleSearch();
        this.$refs.checkboxTable.clearCheckboxReserve();
        this.$refs.checkboxTable.clearCheckboxRow();
        this.$nextTick(() => {
          this.$refs.checkboxTable.setCheckboxRow([], true);
        });
      }
    },
    getSelectedLists () {
      let currentParams = {
        pageFlag: false,
        ids: this.selectedItemLists.map(i => i.attributeId),
      };
      getAttributeLists(currentParams).then(({body}) => {
        let selectedLists = body.list || [];
        this.cloneSelectedLists = (JSON.parse(JSON.stringify(this.selectedItemLists))).map(i=>({
          ...i,
          id: i.attributeId,
        }));
        this.handleSelectionChange(selectedLists);
        this.handleSearch();
      });
    },
    handleSelectionChange (selectedLists) {
      this.selectedLists = selectedLists || [];
      let tempLists = JSON.parse(JSON.stringify(selectedLists));
      let cloneSelectedLists = JSON.parse(JSON.stringify(this.cloneSelectedLists));
      this.cloneSelectedLists = (tempLists || []).map(i => {
        let info = cloneSelectedLists.find(j => j.id === i.id);
        if (info && info.id) {
          i = {
            ...i,
            sort: info.sort,
            required: info.required,
            isIndex: info.isIndex,
            specFlag: info.specFlag,
          };
        }
        return i;
      });
    },
    handleReset () {
      this.form = this.$options.data().form;
      this.handleSearch();
    },
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getTargetLists();
    },
    getTargetLists () {
      let currentParams = {
        ...this.form,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        currentParams.orderBy = [this.sortInfo];
      }
      getAttributeLists(currentParams).then(({body}) => {
        this.pagination.total = body.total;
        this.targetLists = body.list || [];
        this.$nextTick(() => {
          this.$refs.checkboxTable.setCheckboxRow(this.selectedLists, true);
        });
      });
    },
    handleConfirm () {
      if (!this.cloneSelectedLists.length) {
        this.$message.warning(`请${this.dialogTitle}`);
        return;
      }
      let cloneSelectedLists = (this.cloneSelectedLists || []).map(i => ({
        attributeGroupId: this.currentAttributeGroupId,
        categoryId: this.currentId,
        attributeId: i.id,
        attributeName: i.name,
        id: this.selectedItemLists.find(j => j.attributeId === i.id)?.id || '',
        isIndex: i.isIndex,
        required: i.required,
        sort: i.sort,
        specFlag: i.specFlag,
      }));
      batchAddAttributeItem(cloneSelectedLists).then(() => {
        this.selectedLists = [];
        this.cloneSelectedLists = [];
        this.$refs.checkboxTable.clearCheckboxReserve();
        this.$refs.checkboxTable.clearCheckboxRow();
        this.$nextTick(() => {
          this.$refs.checkboxTable.setCheckboxRow(this.selectedLists, true);
        });
        this.$emit('initPage');
        this.isShow = false;
      });
    },
    handleDelete (info) {
      this.cloneSelectedLists = this.cloneSelectedLists.filter(i => i.id !== info.id);
      this.selectedLists = this.selectedLists.filter(i => i.id !== info.id);
      this.$refs.checkboxTable.clearCheckboxReserve();
      this.$refs.checkboxTable.clearCheckboxRow();
      this.getTargetLists();
    },
    handleAddAttribute () {
      this.isShow = false;
      this.$router.push({
        name: 'PlatformSales_ProductAttributes',
        query: {
          isAddAttribute: '1',
          fullPath: `/sales/platform/categories/bindAttribute?id=${this.currentId}&currentAttributeGroupId=${this.currentAttributeGroupId}`,
        },
      });
    },
  },
  computed: {
    columnList () {
      let currentLists = [
        {
          tooltip: true,
          label: '全选',
          type: 'checkbox',
          minWidth: 100,
          fixed: 'left',
        },
        {
          tooltip: true,
          label: '属性名',
          minWidth: '180px',
          prop: 'name',
        },
        {
          tooltip: true,
          label: '数据类型',
          minWidth: '180px',
          prop: 'typeDesc',
        },
        {
          tooltip: true,
          label: '其它描述',
          minWidth: '180px',
          prop: '',
          render: (h, { row }) => {
            let actions = [];
            let msg = row.type === 'BOOLEAN' ? `属性值1：${row.booleanValue1 || ''} 属性值2：${row.booleanValue2 || ''}` : row.type === 'DATE' ? `时间精度：${row.timePrecision}` : row.type === 'NUM' ? `计量单位：${row.unitName}` : '--';
            actions.push(<span>{msg}</span>);
            return h('div', actions);
          },
        },
      ];
      return currentLists;
    },
    selectedColumnList () {
      let currentLists = [
        {
          tooltip: true,
          label: '属性名',
          minWidth: '150px',
          prop: 'name',
        },
        {
          tooltip: true,
          label: '排序',
          minWidth: '180px',
          prop: 'sort',
          render: (h, {row}) => {
            let result = [];
            result.push((
              <el-input-number placeholder="请输入排序" v-model={row.sort} min={0} controls-position="right"></el-input-number>
            ));
            return h('div', result);
          },
        },
        {
          tooltip: true,
          label: '必填',
          minWidth: '150px',
          prop: 'required',
          render: (h, {row}) => {
            let result = [];
            result.push((
              <el-checkbox v-model={row.required} true-label={1} false-label={0} >{}</el-checkbox>
            ));
            return h('div', result);
          },
        },
        {
          tooltip: true,
          label: '索引',
          minWidth: '150px',
          prop: 'isIndex',
          render: (h, {row}) => {
            let result = [];
            result.push((
              <el-checkbox v-model={row.isIndex} true-label={1} false-label={0} >{}</el-checkbox>
            ));
            return h('div', result);
          },
        },
        {
          tooltip: true,
          label: '规格项',
          minWidth: '150px',
          prop: 'specFlag',
          render: (h, {row}) => {
            let result = [];
            result.push((
              <el-checkbox v-model={row.specFlag} true-label={1} false-label={0} >{}</el-checkbox>
            ));
            return h('div', result);
          },
        },
        {
          tooltip: true,
          label: '操作',
          minWidth: '100px',
          prop: 'id',
          fixed: 'right',
          render: (h, {row}) => {
            let result = [];
            result.push((
              <span class="table-action table-action-delete" onClick={()=>this.handleDelete(row)}>删除</span>
            ));
            return h('div', result);
          },
        },
      ];
      return currentLists;
    },
  },
  data () {
    return {
      name: '',
      isRadio: false,
      dialogTitle: '',
      currentTimer: '',
      currentId: '',
      currentAttributeGroupId: '',
      selectedLists: [],
      cloneSelectedLists: [],
      selectedItemLists: [],
      form: {
        name: '',
      },
      checkboxConfig: {
        reserve: true,
        highlight: true,
      },
      targetLists: [],
      isShow: false,
    };
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
/deep/ .vxe-toolbar{
  display: none;
}
</style>
